<template>
  <div class="content-wrapper bg-white shadow-sm">
    <RouterLink to="/" class="btn btn-outline-secondary mb-4"><i class="fa-solid fa-arrow-left"></i> <i class="fa-solid fa-house"></i></RouterLink>

    <h1 class="mb-4">Nutrient pollution: a major freshwater quality concern</h1>
    <p>
Nitrogen (N) and phosphorus (P) are essential for the growth of all living organisms, including aquatic life. Increased use of N and P, particularly in agriculture, has generated both positive and negative effects. Increased use of N and P over the past decades has helped boost crop yields considerably. The downside, however, is that significant fractions of applied N and P find their way to freshwater systems, where these nutrients deteriorate water quality and lead to eutrophication of water bodies.
    </p><p>
This concern is why the Science Based Targets Network (SBTN) developed a <a href="https://sciencebasedtargetsnetwork.org/about/hubs/water/" target="_BLANK">freshwater science-based target</a> that addresses pollution resuling from nutrient loading, specifically nitrogen and phosphorus. The science-based target for water quality is calculated such that nutrient concentrations in water systems remain below the threshold that would incur unacceptable levels of eutrophication. Companies setting a water quality target must calculate the required percent reduction in existing load for all nutrient sources in those basins in which they have priority sites and then define the portion of that amount of reduction (at the basin level) to be allocated to the company’s operations.
    </p>
  </div>

  <section class="py-5 text-center bg-primary mt-5">
    <div class="container">
      <RouterLink to="/map" class="map-btn">
        <div class="goto">
        view the map<br/><i class="fa-solid fa-caret-right"></i><i class="fa-solid fa-caret-right"></i>
        </div>
      </RouterLink>
    </div>
  </section>

  <div class="bottom-hide"></div>
  <div class="bottom-row bg-white">
    <span class="nut">Nutrient Navigator</span>
    <span class="opt">a product from</span>
    <a href="https://sciencebasedtargetsnetwork.org/"><img src="../assets/img/sbtn-logo-yellow.svg"/></a>
    <span class="opt">and</span>
    <a href="https://www.waterfootprint.org/"><img src="../assets/img/wfn-logo.png"/></a>
  </div>
</template>

<script>
export default {
  name: "Concern"
}
</script>

<style>
</style>
